import React from 'react';
import SalesScheduleContainer from '../../containers/schedulemng/SalesScheduleContainer';

const SalesSchedulePage = () => {
  return <SalesScheduleContainer />;
};

export default SalesSchedulePage;
